import React from 'react'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'

import Translate from '../../components/translate'
import LoadingRow from '../../components/loading-row'
import ErrorRow from '../../components/error-row'

import remoteData from '../../shared/remote-data'
import { getVersionInformation } from '../../api/settings'
import * as Store from './store'

const GeneralSettings: React.FC = React.memo(function GeneralSettings() {
    const { state, dispatch } = React.useContext(Store.StoreContext)

    React.useEffect(() => {
        let isMounted = true

        getVersionInformation()
            .then(
                Store.fetchBuildVersionSucceeded,
                Store.fetchBuildVersionFailed
            )
            .then((action) => isMounted && dispatch(action))

        return () => {
            isMounted = false
        }
    }, [])

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <Translate>GENERAL</Translate>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {remoteData.match(state.versionInformation, {
                        notAsked() {
                            return <LoadingRow colSpan={2} />
                        },
                        loading() {
                            return <LoadingRow colSpan={2} />
                        },
                        failed() {
                            return <ErrorRow colSpan={2} />
                        },
                        succeeded(versionInfo) {
                            return (
                                <TableRow data-testid={'build-version'}>
                                    <TableCell>
                                        <Translate>BUILD_VERSION</Translate>
                                    </TableCell>
                                    <TableCell>
                                        {versionInfo.buildVersion}
                                    </TableCell>
                                </TableRow>
                            )
                        },
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
})

export default GeneralSettings
